export const REGISTER_REQUEST = "AUTH.REGISTER_REQUEST";
export const REGISTER_SUCCESS = "AUTH.REGISTER_SUCCESS";
export const REGISTER_FAILURE = "AUTH.REGISTER_FAILURE";

export const LOGIN_REQUEST = "AUTH.LOGIN_REQUEST";
export const LOGIN_SUCCESS = "AUTH.LOGIN_SUCCESS";
export const LOGIN_FAILURE = "AUTH.LOGIN_FAILURE";

export const LOGIN_FACEBOOK_REQUEST = "AUTH.LOGIN_FACEBOOK_REQUEST";
export const LOGIN_FACEBOOK_SUCCESS = "AUTH.LOGIN_FACEBOOK_SUCCESS";
export const LOGIN_FACEBOOK_FAILURE = "AUTH.LOGIN_FACEBOOK_FAILURE";

export const LOGIN_GOOGLE_REQUEST = "AUTH.LOGIN_GOOGLE_REQUEST";
export const LOGIN_GOOGLE_SUCCESS = "AUTH.LOGIN_GOOGLE_SUCCESS";
export const LOGIN_GOOGLE_FAILURE = "AUTH.LOGIN_GOOGLE_FAILURE";

export const GET_CURRENT_USER_REQUEST = "AUTH.GET_CURRENT_USER_REQUEST";
export const GET_CURRENT_USER_SUCCESS = "AUTH.GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAILURE = "AUTH.GET_CURRENT_USER_FAILURE";

export const UPDATE_SHOP_FAVORITE_COUNT = "AUTH.UPDATE_SHOP_FAVORITE_COUNT";

export const UPDATE_EVENT_INTEREST_COUNT = "AUTH.UPDATE_EVENT_INTEREST_COUNT";

export const LOGOUT = "AUTH.LOGOUT";
export const SET_REDIRECT_TO = "AUTH.SET_REDIRECT_TO";
